<a *ngIf="!showAddForm" (click)="showAddForm = true">Add Email</a>
<form *ngIf="showAddForm" class="user-email-input" [formGroup]="form" (submit)="submit()">
    <input
        class="form-control"
        formControlName="addResidentEmail">
    <button type="button" (click)="submit()">
        <i class="fa fa-check"></i>
    </button>
    <button type="button" (click)="showAddForm = false;">
        <i class="fa fa-times"></i>
    </button>
    <spinner [spinnerShow]="loading"></spinner>
</form>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-modal/add-resident-email-form/add-resident-email-form.component.html